/**
 * authSurfaceVariant — FW-131 duzeltme turu (2/2). App.vue'nun `tema` /
 * `gorsel` prop varsayilanlarinin GERCEK kaynagi. Onceki turda bu iki
 * varsayilan App.vue'nun kendi `withDefaults` cagrisinda SABIT LITERAL
 * ('koyu' / true) olarak duruyordu; createSurfaceApp kok bilesene hic prop
 * GECMEDIGI icin (main.ts, createSurfaceApp.ts — grep: 0 eslesme) bu iki
 * varsayilan uretimde ULASILAMAZ bir mekanizma haline geliyordu (olu
 * kontrol: sadece testler @vue/test-utils `mount(App, { props })` ile
 * degeri kendi besliyordu).
 *
 * DUZELTME: App.vue artik varsayilanlarini BURADAN okur — tipki
 * welcomeContent.ts'teki sol panel icerik seedinin ayni gerekcesiyle
 * (bkz. o dosyanin basligi). Tasarimda tema ('Gorunum' bolumu) ve gorsel
 * ('Sol panel' bolumu) ayni kayittadir ve ikisi de Console'un henuz
 * olmayan "Karsilama ekranlari" modulunden tek yerden yonetilecek — bu
 * yuzden ayni SEED dosyasinda birlikte tutulur.
 *
 * Bugun bu SEED, tasarimin (design/current/Auth v2.dc.html) varsayilan
 * degerlerini tasir (tema: 'koyu', gorsel: true) — yani calisan uygulamanin
 * gorunumu bu duzeltmeyle DEGISMEZ. Degisen tek sey: varyantin artik
 * gercek, uretimde okunan bir kaynagi olmasidir; Console geldiginde bu
 * dosyanin degerlerini degistirmek (ya da bir API'den doldurmak) yeterli
 * olacaktir.
 */
import type { AuthThemeName } from './resolveAuthTheme'

export interface AuthSurfaceVariant {
  readonly theme: AuthThemeName
  readonly showImage: boolean
}

/** Giris akisi (id.fusapp.com) icin varsayilan gorunum — tasarimin SEED.giris varsayilanlariyla birebir. */
export const authSurfaceVariant: AuthSurfaceVariant = {
  theme: 'dark',
  showImage: true,
}
